import { Injectable } from '@angular/core';
import { Subject, Subscription } from 'rxjs';

const ServiceName: string = 'Events Broker Service';

@Injectable({
  providedIn: 'root'
})
export class BilEventBrokerService {

  private EventBus = new Subject<any>();

  constructor() {}

  public subscribe(
    callback?: (value: any) => void,
    selector?: (eventInfo: any) => any,
    error?: (error: any) => void,
    complete?: () => void
  ) {
    // Return an observable depending on how subscription was called
    if (typeof callback !== 'function') {
      throw new Error('No callback specified');
    } else {
      return this.EventBus.subscribe(event => (!selector || selector(event)) ? callback(event) : null, error, complete);
    }
  }

  public publish(eventInfo: any): void {
    if (!eventInfo) {
      throw new Error(
        `Publish method must get a valid event`
      );
    } else {
      this.EventBus.next(eventInfo);
    }
  }
}
